import styled from 'styled-components'
import TasksBase from 'lists/tasks'

export const Tasks = styled(TasksBase)`
    margin-bottom: 32px;
`